import { css } from "@emotion/react"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

export const PrivacyPolicy = css`
  p {
    font-family: 'Source Sans Pro', sans-serif;
    margin-bottom: 0;
  }

  a {
    color: ${colorsCP["blue-40"]};
  }
`
